// ==========================================
// FILE: \src\config\firebase.js
// ==========================================

import { initializeApp, getApps, getApp } from "firebase/app";
import { 
  initializeAuth, 
  getReactNativePersistence, 
  getAuth,
  GoogleAuthProvider,
  OAuthProvider
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';

// Identificazione della piattaforma a runtime (Browser Web vs Mobile Nativo)
const isWebPlatform = Platform.OS === 'web';

// Configurazione Adattiva Sicura (Web vs Android)
const firebaseConfig = {
  apiKey: isWebPlatform 
    ? (process.env.EXPO_PUBLIC_FIREBASE_API_KEY || "AIzaSyDWmJYQfTa-Y_FEjgxujV8xLNv6nNZkY50")
    : "AIzaSyABmhpwecshcccwlnxAFL23obgZq6n0ris",
  authDomain: process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN || "vinovault-ea4fc.firebaseapp.com",
  projectId: process.env.EXPO_PUBLIC_FIREBASE_PROJECT_ID || "vinovault-ea4fc",
  storageBucket: process.env.EXPO_PUBLIC_FIREBASE_STORAGE_BUCKET || "vinovault-ea4fc.firebasestorage.app",
  messagingSenderId: process.env.EXPO_PUBLIC_FIREBASE_MESSAGING_SENDER_ID || "1016731205324",
  appId: isWebPlatform 
    ? (process.env.EXPO_PUBLIC_FIREBASE_APP_ID || "1:1016731205324:web:fb8d90f1f55a79c8074c69")
    : "1:1016731205324:android:a693032578108f89074c69"
};

// Inizializzazione sicura dell'App (evita duplicazioni al reload)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Gestione condizionale dell'istanza Auth (Web Browser vs Native Mobile)
let auth;
if (Platform.OS === 'web') {
  auth = getAuth(app); // Istanza standard per Browser (pienamente compatibile con i Popup)
} else {
  auth = initializeAuth(app, {
    persistence: getReactNativePersistence(AsyncStorage) // Istanza nativa per iOS/Android
  });
}

// Inizializzazione globale dei Provider per evitare duplicazioni di prototipo
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('email');
googleProvider.addScope('profile');

export const appleProvider = new OAuthProvider('apple.com');
appleProvider.addScope('email');
appleProvider.addScope('name');

export { auth };
export const db = getFirestore(app);
export const functions = getFunctions(app);